export default {
  /***
   * 新注册用户的默认密码
   * @type {string}
   */
  defaultLoginPassword: 'a123456',
  /***
   * 货币单位
   */
  symbol: process.env.SYMBOL,
  /***
   * 平台名称
   */
  platform: process.env.VUE_APP_NAME,

  /***
   * 默认交易模式: 0 = 极速, 1 = 期货
   */
  defaultTradeType: process.env.VUE_APP_DEFAULT_TYPE,

  /***
   * 新增银行卡是否显示branchCode(支行代码)
   */
  branchCodeEnabled: process.env.VUE_APP_BRANCH_CODE_ENABLED
}



// WEBPACK FOOTER //
// ./src/config/index.js